<template>
  <ValidationObserver ref='validationObserver'>
    <div class="new-form-row">
      <p class="new-form-text">Utilize a nossa conta no Banco Itaú (agência: 0541 / conta corrente: 25450-4 / favorecido: Fundação Ary Frauzino para pes/ CNPJ: 40.226.946/0001-95 – chave PIX:pix@cancer.org.br.)</p>
    </div>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'PixPaymentForm',
  data: function () {
    return {
    };
  },
  methods: {
    validForm: async function () {
      return this.$refs.validationObserver.validate();
    },
    getValidationObserver () {
      return this.$refs.validationObserver;
    }
  }
};
</script>
